import { Component, inject } from '@angular/core';
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';
import { UploadFreightFileModalComponent } from '../upload-freight-file-modal/upload-freight-file-modal.component';

@Component({
  selector: 'lib-upload-freight-file-button',
  templateUrl: './upload-freight-file-button.component.html',
  styleUrls: ['./upload-freight-file-button.component.scss'],
  imports: [IonIcon, IonButton],
})
export class UploadFreightFileButtonComponent {
  private readonly modalCtrl = inject(ModalController);

  async showUploadFreightFileModal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: UploadFreightFileModalComponent,
      componentProps: {},
      backdropDismiss: false,
    });
    modal.present();
  }
}
